import { createRouter, createWebHashHistory } from "vue-router";
import { getCacheV1 } from "@/utils/common";
import emitter from "@/utils/bus";
import index_not from "@/assets/index_not.svg";
import index_ac from "@/assets/index_ac.svg";
import friends_ac from "@/assets/friends_ac.svg";
import friends_not from "@/assets/friends_not.svg";
import wallet_ac from "@/assets/wallet_ac.svg";
import wallet_not from "@/assets/wallet_not.svg";

const routes = [
  {
    path: "/",
    component: () => import("@/view/index.vue"),
    meta: {
      title: "home",
      icon: index_not,
      activeIcon: index_ac,
      isTabbar: true,
    },
  },
  {
    path: "/friends",
    component: () => import("@/view/friends.vue"),
    meta: {
      title: "friends",
      icon: friends_not,
      activeIcon: friends_ac,
      isTabbar: true,
      requiresAuth: true, // 需要登录
    },
  },
  {
    path: "/wallet",
    component: () => import("@/view/wallet.vue"),
    meta: {
      title: "wallet",
      icon: wallet_not,
      activeIcon: wallet_ac,
      isTabbar: true,
      requiresAuth: true, // 需要登录
    },
  },
  /* {
        path: '/test',
        component: () => import('@/view/test.vue'),
        meta: {
            hideNavBar: true,
            showTabbar: false
        },
    }, */
  // 游戏测试路由
  // {
  //     path: '/test2',
  //     component: () => import('@/view/test2.vue'),
  //     meta: {
  //         hideNavBar: true,
  //         showTabbar: false
  //     },
  // },
  {
    path: "/pc",
    component: () => import("@/view/pc.vue"),
    meta: {
      hideNavBar: true,
      showTabbar: false,
    },
  },
  {
    path: "/install-guide",
    component: () => import("@/view/installGuide.vue"),
    meta: {
      title: "install",
      hideNavBar: true,
      showTabbar: false,
    },
  },
  {
    path: "/500",
    component: () => import("@/view/error.vue"),
    meta: {
      title: "error",
      hideNavBar: true,
      showTabbar: false,
    },
  },
  {
    path: "/404",
    component: () => import("@/view/notFound.vue"),
    meta: { hideNavBar: true, showTabbar: false },
  },
  {
    path: "/:pathMatch(.*)", // 必须放在末尾，否则在此之下面的路径都无法使用
    redirect: "/404",
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

/**
 * 路由切换后滚动到顶部
 */
router.afterEach(() => {
  const scrollContainer = document.querySelector(".r_view");
  if (scrollContainer) {
    scrollContainer.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
});

router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || "-";

  // 检测 add_desktop=true 参数，非 PWA 环境下跳转安装引导页
  if (to.path !== "/install-guide") {
    const isPWA =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (!isPWA) {
      // 兼容两种传参方式：?add_desktop=true#/ 或 #/?add_desktop=true
      const mainParams = new URLSearchParams(window.location.search);
      const addDesktop =
        mainParams.get("add_desktop") || to.query.add_desktop;

      if (addDesktop === "true") {
        return next("/install-guide");
      }
    }
  }

  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    const token = getCacheV1("token");
    if (!token) {
      // 未登录，弹出登录框并阻止跳转
      emitter.emit("showLoginRegister");
      return next(false);
    }
  }
  next();
});

export default router;
